import { twMerge } from 'tailwind-merge';
import { useOrder } from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import LoopingEllipsis from '@/components/LoopingEllipsis';
import Divider from '@/components/Divider';
import OrderHeader from '../OrderHeader';
import TimelineSection from './TimelineSection';
import { classes } from './utils';

export type OrderInfoColumnProps = {
  isFetchingData: boolean;
  collapsed: boolean;
  onToggleCollapsed: () => void;
};

export default function OrderInfoColumn({
  isFetchingData,
  collapsed,
  onToggleCollapsed,
}: OrderInfoColumnProps) {
  const { activeOrderId } = useAppState();
  const order = useOrder(activeOrderId);

  if (isFetchingData) {
    return (
      <div className={twMerge(classes.wrapper, classes.expanded)}>
        <div className={classes.loading}>
          Fetching order
          <LoopingEllipsis />
        </div>
      </div>
    );
  }

  if (!order) return null;

  return (
    <div
      className={twMerge(
        classes.wrapper,
        collapsed ? classes.collapsed : classes.expanded
      )}>
      <div className={classes.content}>
        <OrderHeader
          collapsed={collapsed}
          onToggleCollapsed={onToggleCollapsed}
        />
        {!collapsed && (
          <>
            {/*<Addresses />*/}
            <Divider className={classes.divider} />
            <TimelineSection />
          </>
        )}
      </div>
    </div>
  );
}
